/* eslint-disable  */

import React, { useState } from "react"
import { ImBin2 } from "react-icons/im"
import { BiPhone } from "react-icons/bi"
import { Link } from "@reach/router"
import { FaPencilAlt, FaPlus } from "react-icons/fa"
import useAuth from "../../../hooks/useAuth"
import useAxiosPrivate from "../../../hooks/useAxiosPrivate"
import { useLocation } from "@reach/router"
import axiosLib from "axios"
import { functionsEndpoint } from "../../../config"

interface Props extends Address {
  getShippingAddress: () => void
}

const AddressCard = ({
  formatted,
  phone,
  id,
  address1,
  defaultAddress,
  getShippingAddress,
  name,
}: Props) => {
  const { auth } = useAuth()
  const location = useLocation()
  const [loader, setLoader] = useState(false)

  const privateAxios = useAxiosPrivate()

  const deleteMessage = async () => {
    setLoader(true)
    try {
      const result = await axiosLib.post(
        functionsEndpoint + "/delete-address",
        { id },
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
          },
        },
      )

      if (result?.data?.id) {
        await getShippingAddress()
      }
    } catch (err) {
      console.error(err)
    } finally {
      setLoader(false)
    }
  }
  return (
    <div className="lg:max-w-[350px] w-full bg-white py-6 px-5 relative lg:mr-4">
      {defaultAddress && (
        <button className="absolute top-4 left-4 text-white rounded-tl-md rounded-br-md bg-[#C99E1A] px-3 pt-1 flex justify-center items-center font-expanded font-semibold">
          Default
        </button>
      )}
      {loader ? (
        <div role="status">
          <svg
            aria-hidden="true"
            className="w-5 h-5 absolute top-6 right-4 text-gray-200 animate-spin dark:text-gray-600 fill-white"
            viewBox="0 0 100 101"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor"
            />
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="currentFill"
            />
          </svg>
          <span className="sr-only">Loading...</span>
        </div>
      ) : (
        <button onClick={deleteMessage} className="absolute top-6 right-4">
          <ImBin2 />
        </button>
      )}
      <div className="mt-8">
        <h1 className="mb-0 font-extrabold text-base">
          {name || `${auth?.firstName} ${auth?.lastName}`}
        </h1>
        <p className="mb-0 font-normal text-sm">{formatted?.[1]}</p>
        <p className="mb-0 font-normal text-sm">{formatted?.[0] || address1}</p>
        <div className="flex items-center mt-3">
          <BiPhone size={24} />
          <p className="mb-0 text-sm ml-3">{phone}</p>
        </div>
        <Link
          to={`/account/shipping-address/update?id=${id}/${
            location.search ? location.search : ""
          }`}
          className="mb-0 mt-4 flex items-center border-2 border-gray-800 max-w-[180px]"
        >
          <p className="mb-0 border-r-2 border-gray-800 m-0 px-10 py-2 text-lg leading-8 font-bold">
            Edit
          </p>
          <div className="px-3 mb-0 h-full flex justify-center items-center">
            <FaPencilAlt />
          </div>
        </Link>
      </div>
    </div>
  )
}

export default AddressCard
